import { AxiosResponse } from 'axios'
import { api } from '@/lib/api-client.ts'
import { User } from '@/store/user.ts'

export type UserEditData = {
  name?: string
  surname?: string
  email?: string
  activeProjectTabs?: string[]
  activeProjectStage?: string | null
}
export const editUser = async (
  userId: number | undefined,
  userEditData: UserEditData,
): Promise<AxiosResponse<User>> => {
  // console.log(`editing user data...`)
  return api.patch(`/users/${userId}`, userEditData)
}
